import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { useCustomToast } from 'hooks';
import { deleteUserTypeRole } from 'modules/settings/api';

export const useMutationDeleteUserTypeRole = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const { successToast, errorToast } = useCustomToast();

  const { mutateAsync, isLoading, isError, error } = useMutation(deleteUserTypeRole, {
    onSuccess: () => {
      successToast(t('User type successfully removed'));
      queryClient.refetchQueries(QUERY_KEYS.SETTINGS_PROFILE_USER_TYPE_DELETE_ROLE);
    },
    onError: () => errorToast(),
    onSettled: () => queryClient.refetchQueries(QUERY_KEYS.SETTINGS_PROFILE_USER_TYPE_DELETE_ROLE),
  });

  return {
    deleteUserTypeRoleMutate: mutateAsync,
    deleteUserTypeRoleLoading: isLoading,
    isDeleteUserTypeRoleError: isError,
    deleteUserTypeRoleError: (error as any)?.response?.data?.ErrorDescription,
  };
};
